import {
  ABOUT,
  CONTACT,
  HOME,
  STATISTICS,
  DOCS,
  DOCS_ID,
  DIRECTORY,
  ENVIRONMENTAL,
  STATISTICS_ONE,
  QUESTIONS,
  SIS,
  SIS_ONE,
  STATISTICS_DETAIL,
  RESOURCE_DETAIL,
  NEWS,
  NEWS_ONE,
} from "../constants/routes";
import { Routes, Route } from "react-router-dom";
import {
  About,
  Home,
  Contact,
  Statistics,
  Docs,
  DocsView,
  FAQ,
  SISView,
  News,
  NewsDetail,
} from "../components/pages";
import TopicDetail from "../components/pages/TopicDetail";
import Directory from "../components/pages/Directory";
import EnvironmentalInfo from "../components/pages/EnvironmentalInfo";
import SISDetail from "../components/pages/SISDetail";
import CardDetail from "../components/pages/CardDetail";

const AppRoutes = () => (
  <Routes>
    <Route element={<Home />} path={HOME} />
    <Route element={<Contact />} path={CONTACT} />
    <Route element={<About />} path={ABOUT} />
    <Route element={<Statistics />} path={STATISTICS} />
    <Route element={<TopicDetail />} path={STATISTICS_ONE} />
    <Route element={<CardDetail />} path={STATISTICS_DETAIL} />
    <Route element={<CardDetail />} path={RESOURCE_DETAIL} />
    <Route element={<Docs />} path={DOCS} />
    <Route element={<DocsView />} path={DOCS_ID} />
    <Route element={<Directory />} path={DIRECTORY} />
    <Route element={<EnvironmentalInfo />} path={ENVIRONMENTAL} />
    <Route element={<FAQ />} path={QUESTIONS} />
    <Route element={<SISView />} path={SIS} />
    <Route element={<SISDetail />} path={SIS_ONE} />
    <Route element={<News />} path={NEWS} />
    <Route element={<NewsDetail />} path={NEWS_ONE} />
  </Routes>
);

export default AppRoutes;
